/* Leisure Piece · to-scale size preview (CM-52)
   Draws the selected size and frame from the NWF spec inches (shop.metafields.sizing.size_ladder)
   around the product's print image (product.metafields.sizing.print_image).
   The moulding is a CSS border-image cut from the real product photos; the mount, its shadow and the
   wall shadow are drawn. Follows the theme's variant picker (jQuery 'variantChanged' on the product form). */
(function () {
  'use strict';

  var FRAME_KEYS = { 'white': 'white', 'black': 'black', 'natural wood': 'natural', 'dark wood': 'walnut', 'dark walnut': 'walnut', 'light wood': 'natural' };
  var FRAME_NAMES = { white: 'White', black: 'Black', natural: 'Natural Wood', walnut: 'Dark Wood' };

  function frameKey(value) {
    if (!value) return null;
    var v = String(value).toLowerCase();
    if (v.indexOf('no frame') > -1 || v.indexOf('print only') > -1) return 'none';
    for (var k in FRAME_KEYS) if (v.indexOf(k) > -1) return FRAME_KEYS[k];
    return 'white';
  }
  function sizeKey(value) { return String(value || '').split('|')[0].trim(); }
  function fmt(n) { return (n % 1 === 0 ? n : n.toFixed(2).replace(/0$/, '')).toString(); }
  function dims(w, h) { return fmt(w) + '″ × ' + fmt(h) + '″'; }

  function init(root, opts) {
    if (root.dataset.lpInit) return;
    root.dataset.lpInit = '1';
    var ZOOM = !!(opts && opts.zoom);

    var ladder, variants;
    try { ladder = JSON.parse(root.dataset.ladder); variants = JSON.parse(root.dataset.variants); } catch (e) { return; }
    var FACE = ladder.face || 1;
    // Frame + shadow pieces cut from the product mockup photos (one per colour and orientation): the moulding, its corners, the outer wall
    // shadow and the inner shadow on the mount are the mockup's own pixels, stretched 9-slice style. slice/face/margin/ins are in asset px
    // (top, right, bottom, left); the asset is scaled per side so the moulding face renders at the true width in inches.
    var FRAME_SLICES = {
      'land-white': { slice: [91.5, 223.5, 225.5, 91.5], face: [43.5, 45.5, 47.5, 43.5], margin: [20.0, 150.0, 150.0, 20.0], ins: 28.0 },
      'land-black': { slice: [91.5, 223.5, 225.5, 91.5], face: [43.5, 45.5, 47.5, 43.5], margin: [20.0, 150.0, 150.0, 20.0], ins: 28.0 },
      'land-natural': { slice: [91.5, 223.5, 225.5, 91.5], face: [43.5, 45.5, 47.5, 43.5], margin: [20.0, 150.0, 150.0, 20.0], ins: 28.0 },
      'land-dark': { slice: [91.5, 223.5, 225.5, 91.5], face: [43.5, 45.5, 47.5, 43.5], margin: [20.0, 150.0, 150.0, 20.0], ins: 28.0 },
      'port-white': { slice: [87.5, 208.0, 208.0, 87.0], face: [41.5, 42.0, 42.0, 41.0], margin: [20.0, 140.0, 140.0, 20.0], ins: 26.0 },
      'port-black': { slice: [87.5, 208.0, 208.0, 87.0], face: [41.5, 42.0, 42.0, 41.0], margin: [20.0, 140.0, 140.0, 20.0], ins: 26.0 },
      'port-natural': { slice: [87.5, 208.0, 208.0, 87.0], face: [41.5, 42.0, 42.0, 41.0], margin: [20.0, 140.0, 140.0, 20.0], ins: 26.0 },
      'port-dark': { slice: [87.5, 208.0, 208.0, 87.0], face: [41.5, 42.0, 42.0, 41.0], margin: [20.0, 140.0, 140.0, 20.0], ins: 26.0 }
    };
    // How far each cut's wall shadow shows past the moulding, in asset px (top, right, bottom, left): measured from the PNGs where it
    // fades below 2.5% on white (all four colours; the transparent top/left margin is kept whole). The drawing keeps this room (CM-93).
    var SHADOW_REACH = { land: [20, 108, 125, 20], port: [20, 115, 95, 20] };
    var sizes = ladder.sizes || {};
    var sizeIdx = parseInt(root.dataset.sizeIndex, 10), frameIdx = parseInt(root.dataset.frameIndex, 10);
    var artSrc = root.dataset.art, artW = parseInt(root.dataset.artW, 10) || 3, artH = parseInt(root.dataset.artH, 10) || 2;
    var portrait = artH > artW;
    var frames = {};
    ['white', 'black', 'natural', 'walnut'].forEach(function (k) { var K = k.charAt(0).toUpperCase() + k.slice(1); frames[k] = { src: root.dataset['frame' + K], mount: root.dataset['mount' + K] || '#f3f3f3', land: root.dataset['sliceLand' + K], port: root.dataset['slicePort' + K] }; });
    var SLICE = parseInt(root.dataset.frameSlice, 10) || 72;

    // size rows available on this product, in option order
    var sizeValues = JSON.parse(root.dataset.sizeValues || '[]');
    var rows = sizeValues.map(function (v) { var k = sizeKey(v); return { value: v, key: k, spec: sizes[k] || null }; }).filter(function (r) { return r.spec; });
    if (!rows.length) return;

    var el = {
      select: root.querySelector('.lp-sp__select'),
      diagram: root.querySelector('.lp-sp__diagram'),
      piece: root.querySelector('.lp-sp__piece'),
      ann: root.querySelector('.lp-sp__ann'),
      lp: root.querySelector('[data-lbl="print"]'),
      lf: root.querySelector('[data-lbl="frame"]'),
      lo: root.querySelector('[data-lbl="overall"]'),
      soldout: root.querySelector('.lp-sp__soldout')
    };

    var state = { size: rows[0].key, frame: 'white', available: true };

    function geom(spec) {
      var pw = portrait ? spec.ph : spec.pw, ph = portrait ? spec.pw : spec.ph;
      var m = spec.m, fw = pw + 2 * m, fh = ph + 2 * m;
      var face = spec.face || FACE; // per-size moulding width (Masterpiece uses a 2" frame)
      return { pw: pw, ph: ph, m: m, face: face, fw: fw, fh: fh, ow: fw + 2 * face, oh: fh + 2 * face, label: spec.moulding_label || ladder.moulding_label || '' };
    }

    function pieceHTML(spec, wpx) {
      var g = geom(spec), printOnly = state.frame === 'none', key = state.frame;
      var W = printOnly ? g.pw : g.ow, H = printOnly ? g.ph : g.oh, k = wpx / W;
      var x = '<div class="lp-pc" style="width:' + (W * k) + 'px;height:' + (H * k) + 'px">';
      if (!printOnly) {
        var fr = frames[key] || frames.white, B = g.face * k;
        var ori = portrait ? 'port' : 'land', sm = FRAME_SLICES[ori + '-' + (key === 'walnut' ? 'dark' : key)] || FRAME_SLICES[ori + '-white'];
        var src = fr[ori] || frames.white[ori];
        // per-side scale so the moulding face is exactly B px; margins (outer shadow) and ins (inner shadow) scale with it
        var sc = [0, 1, 2, 3].map(function (i) { return B / sm.face[i]; });   // top, right, bottom, left
        var bw = [0, 1, 2, 3].map(function (i) { return ((sm.margin[i] + sm.face[i] + sm.ins) * sc[i]).toFixed(2) + 'px'; }).join(' ');
        var mt = sm.margin[0] * sc[0], mr = sm.margin[1] * sc[1], mb = sm.margin[2] * sc[2], ml = sm.margin[3] * sc[3];
        x += '<div class="lp-pfs" style="left:' + (-ml) + 'px;top:' + (-mt) + 'px;width:' + (W * k + ml + mr) + 'px;height:' + (H * k + mt + mb) + 'px;border-width:' + bw + ';border-image:url(' + src + ') ' + sm.slice.join(' ') + ' fill / ' + bw + ' stretch"></div>';
      }
      var px = printOnly ? 0 : (g.m + g.face) * k;
      var ps = printOnly ? '' : 'box-shadow:' + (0.1 * k) + 'px ' + (0.14 * k) + 'px ' + (0.22 * k) + 'px rgba(0,0,0,.2)';
      x += '<img class="lp-ppr" src="' + artSrc + '" alt="" loading="lazy" style="left:' + px + 'px;top:' + px + 'px;width:' + (g.pw * k) + 'px;height:' + (g.ph * k) + 'px;' + ps + '">';
      return x + '</div>';
    }

    function labelZone(W) { return ZOOM ? (W < 430 ? 96 : 160) : Math.min(160, Math.max(120, Math.round(W * 0.32))); }
    function share(longIn, W) {
      var mn = ZOOM ? (W < 430 ? 0.84 : 0.68) : (W < 430 ? 0.66 : 0.55), mx = ZOOM ? 0.96 : 0.92;
      return Math.min(mn + (longIn - 16.5) / (85 - 16.5) * (mx - mn), ZOOM ? 0.95 : 0.9);
    }
    // one size drawn framed at k px per inch: its frame box and how far its shadow shows on each side, in px
    function reach(spec, k) {
      var g = geom(spec), ori = portrait ? 'port' : 'land', f = FRAME_SLICES[ori + '-white'].face, R = SHADOW_REACH[ori], B = g.face * k;
      return { w: g.ow * k, h: g.oh * k, t: R[0] * B / f[0], r: R[1] * B / f[1], b: R[2] * B / f[2], l: R[3] * B / f[3] };
    }
    // the widest of the three labels over every size (their text follows the size), so the piece never runs into them
    var lblW = {};
    function labelsWidth(W) {
      var key = W + (ZOOM ? 'z' : '');
      if (lblW[key]) return lblW[key];
      var mx = 0;
      rows.forEach(function (r) {
        var g = geom(r.spec);
        el.lp.innerHTML = root.dataset.tPrint + '<span>' + dims(g.pw, g.ph) + '</span>';
        el.lf.innerHTML = root.dataset.tFrame + '<span>' + g.label + '</span>';
        el.lo.innerHTML = root.dataset.tOverall + '<span>' + dims(g.ow, g.oh) + '</span>';
        mx = Math.max(mx, el.lp.offsetWidth, el.lf.offsetWidth, el.lo.offsetWidth);
      });
      return (lblW[key] = mx);
    }
    // the expanded view's height for the drawing: the screen less the overlay's and the panel's padding (and the sold-out line)
    function zoomRoom() {
      var p = root.parentNode, o = p && p.parentNode;
      if (!o || !o.classList || !o.classList.contains('lp-zoom')) return Infinity;
      var cp = getComputedStyle(p), co = getComputedStyle(o), so = el.soldout && !el.soldout.hidden ? el.soldout.offsetHeight + 8 : 0;
      return window.innerHeight - parseFloat(co.paddingTop) - parseFloat(co.paddingBottom) - parseFloat(cp.paddingTop) - parseFloat(cp.paddingBottom) - so;
    }

    function render() {
      var row = rows.filter(function (r) { return r.key === state.size; })[0] || rows[0];
      var spec = row.spec, printOnly = state.frame === 'none';
      var D = el.diagram, W = D.clientWidth; if (!W) return;
      root.classList.toggle('lp-sp--soldout', !state.available);
      if (el.soldout) el.soldout.hidden = state.available;
      var g = geom(spec);
      // Every size grows around one centre. The room is sized from all of them at once (the biggest frame, the farthest shadow,
      // which on small sizes is the thicker moulding's), so no size, frame or orientation is ever clipped (CM-93: the old height
      // was kept for a piece 78% of the zone while the big sizes drew at up to 95%, so tall pieces ran off the top).
      var LZ = Math.max(labelZone(W), 2 + labelsWidth(W) + (W < 430 ? 8 : 16)), IZ = W - LZ, PT = 24, PB = 16, PR = W < 430 ? 6 : 12;
      var scale = function (sp) { var gg = geom(sp), L = portrait ? gg.oh : gg.ow; return share(L, W) * IZ / L; };
      var ext = { l: 0, r: 0, t: 0, b: 0 };
      rows.forEach(function (r) {
        var x = reach(r.spec, scale(r.spec));
        ext.l = Math.max(ext.l, x.w / 2 + x.l); ext.r = Math.max(ext.r, x.w / 2 + x.r);
        ext.t = Math.max(ext.t, x.h / 2 + x.t); ext.b = Math.max(ext.b, x.h / 2 + x.b);
      });
      var f = Math.min(1, (IZ - PR) / (ext.l + ext.r));
      if (ZOOM) f = Math.min(f, (zoomRoom() - PT - PB) / (ext.t + ext.b)); // the expanded view fits the screen without scrolling
      f = Math.max(f, 0.5);
      var H = Math.ceil(PT + f * (ext.t + ext.b) + PB); D.style.height = H + 'px';
      var cx = (LZ + W - PR) / 2 + f * (ext.l - ext.r) / 2, cy = PT + f * ext.t;
      var k = f * scale(spec);
      var Wp = (printOnly ? g.pw : g.ow) * k, Hp = (printOnly ? g.ph : g.oh) * k;
      var ix = cx - Wp / 2, iy = cy - Hp / 2;
      el.piece.style.left = ix + 'px'; el.piece.style.top = iy + 'px';
      el.piece.innerHTML = pieceHTML(spec, Wp);

      var off = printOnly ? 0 : (g.m + g.face) * k;
      var pr = { l: ix + off, t: iy + off, r: ix + off + g.pw * k, b: iy + off + g.ph * k }, fr = { l: ix, t: iy, r: ix + Wp, b: iy + Hp };
      var g0 = geom(rows[0].spec), H0 = g0.oh * f * scale(rows[0].spec), top0 = cy - H0 / 2;
      el.ann.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      var R = ZOOM && W >= 430 ? 4.5 : 3.5, OFF = W < 430 ? 33 : 40, s = '';
      var seg = function (x1, y1, x2, y2) { return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"/>'; };
      var dot = function (x, y) { return '<circle cx="' + x + '" cy="' + y + '" r="' + R + '"/>'; };
      var py = top0 + H0 * 0.22, pdx = pr.l + (pr.r - pr.l) * 0.30;
      s += seg(4, py, pdx - R, py) + dot(pdx, py);
      el.lp.innerHTML = root.dataset.tPrint + '<span>' + dims(g.pw, g.ph) + '</span>'; el.lp.style.top = (py - OFF) + 'px';
      if (printOnly) { el.lf.innerHTML = ''; el.lo.innerHTML = ''; }
      else {
        var fy = top0 + H0 * 0.60, fdx = fr.l + g.face * k * 0.5;
        s += seg(4, fy, fdx - R, fy) + dot(fdx, fy);
        el.lf.innerHTML = root.dataset.tFrame + '<span>' + g.label + '</span>'; el.lf.style.top = (fy - OFF) + 'px';
        var oy = (pr.b + fr.b) / 2, odx = fr.r - 1;
        s += seg(4, oy, odx - R, oy) + dot(odx, oy);
        el.lo.innerHTML = root.dataset.tOverall + '<span>' + dims(g.ow, g.oh) + '</span>'; el.lo.style.top = (oy - OFF) + 'px';
      }
      el.ann.innerHTML = s;
      if (el.select && el.select.value !== row.value) el.select.value = row.value;
    }

    // ---- availability per size for the current frame ----
    function availableFor(sizeValue, frameValueKey) {
      return variants.some(function (v) {
        return sizeKey(v.o[sizeIdx]) === sizeKey(sizeValue) && (frameIdx < 0 || frameKey(v.o[frameIdx]) === frameValueKey) && v.a;
      });
    }
    function fillSelect() {
      if (!el.select) return;
      el.select.innerHTML = '';
      rows.forEach(function (r) {
        var o = document.createElement('option');
        var ok = availableFor(r.value, state.frame);
        o.value = r.value; o.disabled = !ok;
        o.textContent = r.key + (ok ? '' : '   ·   ' + root.dataset.tSoldout); // size name only; the drawing shows the inches
        el.select.appendChild(o);
      });
    }

    // ---- follow the theme's variant picker ----
    function applyVariant(v) {
      if (!v) return;
      var opts = v.options || [v.option1, v.option2, v.option3];
      var sk = sizeKey(opts[sizeIdx]); if (sizes[sk]) state.size = sk;
      state.frame = frameIdx >= 0 ? (frameKey(opts[frameIdx]) || 'white') : 'white';
      state.available = !!v.available;
      fillSelect(); render();
    }
    // Symmetry dispatches a bubbling native 'change' on the [name="id"] input with detail.variant on every variant change,
    // and a jQuery 'variantChanged' on the .product-form container. Listen to both.
    var detailEl = root.closest('.product-detail') || document;
    detailEl.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id' && e.detail && e.detail.variant) applyVariant(e.detail.variant);
    });
    var pf = root.closest('.product-form');
    if (pf && window.jQuery) window.jQuery(pf).on('variantChanged', function (evt, variant) { applyVariant(variant); });
    // initial state from the data attribute (selected_or_first_available_variant)
    try { applyVariant(JSON.parse(root.dataset.current)); } catch (e) { fillSelect(); render(); }

    // the accordion's own size select drives the theme's Size selector (so price, cart and URL all follow)
    if (el.select) el.select.addEventListener('change', function () {
      var value = el.select.value;
      var detail = root.closest('.product-detail') || document;
      var sel = detail.querySelector('.option-selector[data-option-index="' + sizeIdx + '"]');
      var cc = sel && sel.querySelector('.cc-select');
      if (cc) {
        // the theme's own hook: CustomSelect listens for 'selectOption' and updates the variant, price, URL and cart form
        cc.dispatchEvent(new CustomEvent('selectOption', { detail: { value: value } }));
      } else if (sel) {
        var radio = Array.prototype.find.call(sel.querySelectorAll('input.js-option'), function (i) { return i.value === value; });
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      } else { state.size = sizeKey(value); render(); }
    });

    root.lpApi = {
      get: function () { return { size: state.size, frame: state.frame, available: state.available }; },
      set: function (st) { state.size = st.size; state.frame = st.frame; state.available = st.available; fillSelect(); render(); },
      render: render
    };

    // ---- click to expand: the same drawing, bigger, in a full-screen overlay ----
    if (!ZOOM && el.diagram) {
      var zoom = null;
      var closeZoom = function () {
        if (!zoom) return;
        zoom.ov.classList.remove('is-open'); document.documentElement.classList.remove('lp-zoom-open');
        document.removeEventListener('keydown', onKey);
      };
      var onKey = function (e) { if (e.key === 'Escape') closeZoom(); };
      var openZoom = function () {
        if (!zoom) {
          var ov = document.createElement('div'); ov.className = 'lp-zoom'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true');
          ov.innerHTML = '<div class="lp-zoom__panel"><button type="button" class="lp-zoom__close" aria-label="Close"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button></div>';
          var panel = ov.firstChild, c = root.cloneNode(true);
          c.removeAttribute('data-lp-init'); c.classList.add('lp-sp--zoom');
          var sw = c.querySelector('.lp-sp__selectwrap'); if (sw) sw.parentNode.removeChild(sw); // the drawing only; sizes are picked on the page
          panel.appendChild(c); document.body.appendChild(ov); init(c, { zoom: true });
          ov.addEventListener('click', function (e) { if (e.target === ov || (e.target.closest && e.target.closest('.lp-zoom__close'))) closeZoom(); });
          zoom = { ov: ov, sp: c };
        }
        if (zoom.sp.lpApi) zoom.sp.lpApi.set(state);
        zoom.ov.classList.add('is-open'); document.documentElement.classList.add('lp-zoom-open');
        document.addEventListener('keydown', onKey);
        requestAnimationFrame(function () { if (zoom.sp.lpApi) zoom.sp.lpApi.render(); });
      };
      el.diagram.setAttribute('role', 'button'); el.diagram.setAttribute('tabindex', '0'); el.diagram.setAttribute('aria-label', 'Expand size preview');
      el.diagram.addEventListener('click', openZoom);
      el.diagram.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openZoom(); } });
    }

    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(render, 80); });
    // accordion opens after load: re-measure when it becomes visible
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) render(); }); }).observe(root);
    // the labels are measured: measure again once the fonts are in
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { lblW = {}; render(); });
  }

  function boot() { document.querySelectorAll('.lp-sp:not(.lp-sp--zoom)').forEach(function (r) { init(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
